import { twMerge } from "tailwind-merge";

import CollectionSnippetPlacholder from "components/CollectionSnippet/placeholder";

const LoadingPlaceholder = ({
  className,
  noContainer,
}: {
  className?: string;
  noContainer?: boolean;
}) => {
  const placeholders = (
    <>
      <CollectionSnippetPlacholder type="cardV3" />
      <CollectionSnippetPlacholder type="cardV3" />
      <CollectionSnippetPlacholder type="cardV3" />
      <CollectionSnippetPlacholder type="cardV3" className="hidden md:flex" />
      <CollectionSnippetPlacholder type="cardV3" className="hidden md:flex" />
      <CollectionSnippetPlacholder type="cardV3" className="hidden md:flex" />
    </>
  );

  if (noContainer) return placeholders;

  return (
    <div
      className={twMerge(
        "flex flex-wrap gap-[30px] mb-[20px] mt-[-20px]",
        className
      )}
    >
      {placeholders}
    </div>
  );
};

export default LoadingPlaceholder;
